module.exports = __webpack_public_path__ + "static/7-172f842d70cd6e0c0f8052eb7818e82e.jpg";